import React from 'react';
import { makeStyles } from '@material-ui/core';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import CopyToClipboardButton from 'Components/UI/CopyToClipboardButton';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: theme.spacing(0, 1),
  },
  attribute: {
    flex: '0 0 20%',
    wordBreak: 'break-all',
    position: 'relative',
  },
  meta: {
    paddingRight: theme.spacing(6),
  },
  supportLink: {
    fontSize: theme.typography.fontSize1Rem,
    lineHeight: '1.1876em',
  },
  label: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.facet.primaryGray,
    marginBottom: theme.spacing(1),
  },
  copyToClipboard: {
    position: 'absolute',
    top: '20px',
    right: theme.spacing(2),
  },
}));

const LinkingAttemptLayout = () => {
  const classes = useStyles();
  const { resource } = useMetaLayoutContext();

  return (
    <div className={classes.root}>
      {resource.attr('institutionId') && (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="institutionId" />
        </div>
      )}
      {resource.attr('timestamp') && (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="timestamp" />
        </div>
      )}
      {resource.attr('sessionId') && (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="sessionId" />
          <div className={classes.copyToClipboard}>
            <CopyToClipboardButton string={resource.attr('sessionId')} />
          </div>
        </div>
      )}
      {resource.attr('platform') && (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="platform" />
        </div>
      )}
      {resource.attr('providerId') && (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="providerId" />
        </div>
      )}
      {resource.attr('providerName') && (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="providerName" />
        </div>
      )}
      {resource.attr('customerId') && (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="customerId" />
          <div className={classes.copyToClipboard}>
            <CopyToClipboardButton string={resource.attr('customerId')} />
          </div>
        </div>
      )}
      {resource.attr('providerAccountId') && (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="providerAccountId" />
          <div className={classes.copyToClipboard}>
            <CopyToClipboardButton string={resource.attr('providerAccountId')} />
          </div>
        </div>
      )}
      {resource.attr('requestId') && (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="requestId" />
          <div className={classes.copyToClipboard}>
            <CopyToClipboardButton string={resource.attr('requestId')} />
          </div>
        </div>
      )}
      {resource.attr('eventType') && (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="eventType" />
        </div>
      )}
      {resource.attr('status') && (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="status" />
        </div>
      )}
      {resource.attr('additionalStatus') && (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="additionalStatus" />
        </div>
      )}
      {resource.attr('reason') && (
        <div>
          <MetaField className={classes.meta} attr="reason" />
        </div>
      )}
      {resource.attr('supportLink') && (
        <div>
          <div className={classes.label}>Support Link</div>
          <a
            className={classes.supportLink}
            href={resource.attr('supportLink')}
            target="_blank"
            rel="noopener noreferrer"
          >
            {resource.attr('supportLink')}
          </a>
        </div>
      )}
    </div>
  );
};

export default LinkingAttemptLayout;
